import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'

export function AdminGuard({ children }: { children: ReactNode }) {
  const isLoading = useAuthStore((s) => s.isLoading)
  const isAdmin = useAuthStore((s) => s.isAdmin)

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-100">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
      </div>
    )
  }

  if (!isAdmin) {
    return <Navigate to="/auth/login" replace />
  }

  return <>{children}</>
}
